import LogCancelText from '@/log/components/LogCancelText'
import LogText from '@/log/components/LogText'
import EyesIcon from '@/log/components/EyesIcon'
import LogDetailsModal from '@/log/modals/LogDetailsModal'
import { Box, IconButton, Tooltip, useDisclosure } from '@chakra-ui/react'
import { LogFragment } from '@gql'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { logHasDetails } from '@/log/logChangeSummary'
import NewsItemLayout from './NewsItemLayout'

interface Props {
  log: LogFragment
}

// A change to the org chart, as a news card (ACTU-01, #48): who, what, when.
// No role tag on the right: the sentence names the role already (#114).
export default function NewsLog({ log }: Props) {
  const { t } = useTranslation()
  const detailsModal = useDisclosure()

  return (
    <>
      <NewsItemLayout
        sentence={
          <Box
            as="span"
            textDecoration={log.canceled ? 'line-through' : undefined}
          >
            <LogCancelText log={log} />
            <LogText log={log} />
          </Box>
        }
        date={log.createdAt}
        memberId={log.cancelMemberId || log.memberId}
        action={
          logHasDetails(log) && (
            // The governance purple, as the tab: this opens a governance change
            <Tooltip label={t('NewsLog.details')} hasArrow>
              <IconButton
                aria-label={t('NewsLog.details')}
                icon={<EyesIcon boxSize={4} />}
                size="xs"
                isRound
                bg="purple.100"
                color="purple.800"
                _hover={{ bg: 'purple.200' }}
                _dark={{
                  bg: 'purple.700',
                  color: 'purple.50',
                  _hover: { bg: 'purple.600' },
                }}
                onClick={detailsModal.onOpen}
              />
            </Tooltip>
          )
        }
      />
      {detailsModal.isOpen && (
        <LogDetailsModal log={log} isOpen onClose={detailsModal.onClose} />
      )}
    </>
  )
}
